export enum SeriesTypeEnum {
  electricity = 'electricity',
  gas = 'gas',
  water = 'water',
  pressurizedAir = 'pressurizedAir',
  fuels = 'fuels',
  fluidGas = 'fluidGas',
  heating = 'heating',
  special = 'special',
  custom = 'custom',
  virtualMeter = 'virtual meter',
  temperature = 'temperature',
}
